import { gql } from '@apollo/client'

const OPERATION_SEARCH_CONTACT = gql`
  query GetContacts(
    $site_ids: [String]
    $verbatim: String
    $created_at_start: String
    $created_at_end: String
    $internal: Boolean
    $status: [String]
    $sync: [String]
    $roles: [String]
    $offset: Int
    $limit: Int
    $sort_by: String
    $sort_direction: String
  ) {
    contacts: searchContact(
      site_ids: $site_ids
      verbatim: $verbatim
      created_at_start: $created_at_start
      created_at_end: $created_at_end
      internal: $internal
      status: $status
      sync: $sync
      roles: $roles
      offset: $offset
      limit: $limit
      sort_by: $sort_by
      sort_direction: $sort_direction
    ) {
      id
      sf_id
      center_user_id
      admin
      first_name
      country
      last_name
      email
      created_at
      nb_sites
      internal
      state
      sync
      mobile_phone
      last_sign_in_at
      deleted_at
      roles
      locked  
    }
  }
`

export const OPERATION_CAN_EDIT_CONTACT = gql`
  query CanEditContact($sf_id: ID!) {
    canEdit: canEditContact(sf_id: $sf_id)
  }
`
export const OPERATION_FIND_CONTACT = gql`
  query GetContact($sf_id: String!, $with_accounts: Boolean!) {
    contact: findContact(sf_id: $sf_id) {
      id  
      sf_id
      center_user_id
      admin
      first_name
      last_name
      email
      title
      salutation  
      country
      state
      sync
      nb_sites
      internal
      last_sign_in_at
      last_modified_by {
        type
        label
        email
        internal
      }
      deleted_at
      langue
      phone
      mobile_phone
      created_at
      updated_at
      deleted_at
      roles
      locked  
      creator {
        first_name
        last_name  
        internal  
        email  
      }  
      accounts @include(if: $with_accounts) {
          id
          sf_id
          sf_parent_id
          nb_children,
          hierarchie,
          name,
          is_site
      }  
      two_fa_activated
      password_locked_at
      password_lock_reason
    }
  }
`

export const OPERATION_FIND_CONTACT_SITES = gql`
  query GetContactSites($sf_id: String!, $offset: Int, $limit: Int) {
    sites: findContactSites(sf_id: $sf_id, offset: $offset, limit: $limit) {
      id
      name
    }
  }
`

export const OPERATION_COUNT_STATUS = gql`
  query AggContactStates {
    states: aggContactStates {
      key
      count
    }
  }
`

export const OPERATION_COUNT_SYNC = gql`
  query AggContactSync($site_ids: [String]) {
    values: aggContactSync(site_ids: $site_ids) {
      key
      count
    }
  }
`
export const OPERATION_EXPORT_CONTACTS = gql`
  query ExportContacts(
    $site_ids: [String], 
    $verbatim: String, 
    $created_at_start: String, 
    $created_at_end: String, 
    $internal: Boolean, 
    $status: [String], 
    $roles: [String],
    $format: String!,
    $language: String
  ) {
    exportContacts(
      site_ids: $site_ids
      verbatim: $verbatim
      created_at_start: $created_at_start
      created_at_end: $created_at_end
      internal: $internal
      status: $status
      roles: $roles
      format: $format
      language: $language
    )
  }
`

export default OPERATION_SEARCH_CONTACT
